import React, { useEffect, useRef, useState } from "react";

// Google Drive's /preview player crops/zooms the video when the iframe is
// narrow (mobile). We render it at a desktop size and scale it down so the
// whole frame is always visible (letterboxed), like on desktop.
const BASE_W = 854;
const BASE_H = 480;

export const ScaledVideoFrame = ({ src, title, testId }) => {
  const boxRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = boxRef.current;
    if (!el) return undefined;
    const update = () => setScale(Math.min(1, el.clientWidth / BASE_W));
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const scaled = scale < 1;
  return (
    <div ref={boxRef} className="relative w-full overflow-hidden bg-black" style={{ aspectRatio: "16 / 9" }}>
      <iframe
        data-testid={testId}
        src={src}
        title={title}
        loading="lazy"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
        allowFullScreen
        frameBorder="0"
        scrolling="no"
        className="absolute top-0 left-0 border-0"
        style={scaled
          ? { width: BASE_W, height: BASE_H, transform: `scale(${scale})`, transformOrigin: "top left" }
          : { width: 1, minWidth: "100%", height: "100%" }}
      />
    </div>
  );
};
